const replaceLocationState = () => {
    window.history.replaceState(null, '');
};

export default replaceLocationState;
